module.exports = __webpack_public_path__ + "flags.cb057877085d8ef838b8.png";


//////////////////
// WEBPACK FOOTER
// D:/TELEMED-FINAL/telemed/src/assets/img/flags/flags.png
// module id = ../../../../../src/assets/img/flags/flags.png
// module chunks = styles